"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.array.reduce");
require("core-js/modules/es.object.entries");
require("core-js/modules/es.object.to-string");
require("core-js/modules/es.regexp.exec");
require("core-js/modules/es.regexp.to-string");
require("core-js/modules/es.string.replace");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyString = exports.getPropertyNumber = exports.getPropertyDocument = exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _DetailsTabRow = _interopRequireDefault(require("../enums/config/DetailsTabRow"));
var _isNumber = require("../utils/isNumber");
var _convertorHelper = require("./convertorHelper");
var _getDictionaryValue = _interopRequireDefault(require("./getDictionaryValue"));
var _replaceHelper = require("./replaceHelper");
var _stringHelper = require("./stringHelper");
var getPropertyString = function getPropertyString(rowConfig, product) {
  var value = (0, _get.default)(product, rowConfig.property);
  if ((0, _isNil.default)(value) || value === '') {
    return rowConfig.defaultValue;
  }
  var tail = (0, _stringHelper.makeUnit)(rowConfig.unit, value, product);
  return rowConfig.template ? (0, _replaceHelper.replaceTemplate)(rowConfig.template, ['property', 'unit'], {
    property: value,
    unit: tail
  }) : "" + value + (tail ? " " + tail : '');
};
exports.getPropertyString = getPropertyString;
var getPropertyDocument = function getPropertyDocument(rowConfig, product) {
  var value = (0, _get.default)(product, rowConfig.property);
  if ((0, _isNil.default)(value) || value === '') {
    return null;
  }
  return [value, rowConfig.template];
};
exports.getPropertyDocument = getPropertyDocument;
var getPropertyNumber = function getPropertyNumber(rowConfig, product) {
  var value = (0, _get.default)(product, rowConfig.property);
  if (!(0, _isNumber.isNumber)(value)) {
    return rowConfig.defaultValue;
  }
  var text = rowConfig.numberTemplate ? (0, _convertorHelper.toFinanceString)(value, {
    template: rowConfig.numberTemplate
  }) : value;
  var tail = (0, _stringHelper.makeUnit)(rowConfig.unit, value, product);
  return rowConfig.template ? (0, _replaceHelper.replaceTemplate)(rowConfig.template, ['property', 'unit'], {
    property: text,
    unit: tail
  }) : "" + text + (tail ? " " + tail : '');
};

// eslint-disable-next-line max-statements,complexity
exports.getPropertyNumber = getPropertyNumber;
var getProperty = function getProperty(config, rowConfig, product, dictionaries) {
  if (!rowConfig) {
    return null;
  }
  switch (rowConfig.type) {
    case _DetailsTabRow.default.Wysiwyg:
      {
        return (0, _get.default)(product, rowConfig.property) || rowConfig.defaultValue;
      }
    case _DetailsTabRow.default.Range:
      {
        return (0, _stringHelper.makeRangeString)({
          product,
          config: rowConfig
        });
      }
    case _DetailsTabRow.default.Boolean:
      {
        var trueValue = (0, _isNil.default)(rowConfig.true) ? 'Да' : rowConfig.true;
        var falseValue = (0, _isNil.default)(rowConfig.false) ? 'Нет' : rowConfig.false;
        return (0, _get.default)(product, rowConfig.property) ? trueValue : falseValue;
      }
    case _DetailsTabRow.default.Document:
      {
        return getPropertyDocument(rowConfig, product);
      }
    case _DetailsTabRow.default.String:
      {
        return getPropertyString(rowConfig, product);
      }
    case _DetailsTabRow.default.Number:
      {
        return getPropertyNumber(rowConfig, product);
      }
    case _DetailsTabRow.default.Date:
      {
        var value = (0, _get.default)(product, rowConfig.property);
        if ((0, _isNil.default)(value)) {
          return rowConfig.defaultValue;
        }
        return new Date(value.toString()).toLocaleDateString();
      }
    case _DetailsTabRow.default.List:
      {
        return (0, _stringHelper.makeListToString)({
          product,
          config: rowConfig
        });
      }
    case _DetailsTabRow.default.Dictionary:
      {
        return (0, _getDictionaryValue.default)(product, rowConfig, config, dictionaries);
      }
    case _DetailsTabRow.default.TemplateWysiwyg:
    case _DetailsTabRow.default.Template:
      {
        return Object.entries(rowConfig.properties).reduce(
        // eslint-disable-next-line max-nested-callbacks
        function (acc, _ref) {
          var key = _ref[0],
            property = _ref[1];
          return acc.replace("%" + key + "%", getProperty(config, property, product, dictionaries));
        }, rowConfig.template);
      }
    default:
      {
        throw new Error("Can't find type in DetailsTabRow");
      }
  }
};
var _default = getProperty;
exports.default = _default;